export default function SylmanSupportSection() {
  return (
    <section className="section-wrap bg-[#2D7F3E]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading text-white">
            How Sylman Academy Supports Your Compliance
          </h2>
          <p className="text-xl text-green-100 max-w-3xl mx-auto">
            Comprehensive SETA compliance support to maximise your funding recovery and ensure regulatory adherence
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="card p-6">
            <div className="icon-box mb-4">
              <i className="ri-file-edit-line text-xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              WSP & ATR Preparation
            </h3>
            <p className="text-gray-600 mb-4">
              Complete preparation and submission of your Workplace Skills Plan and Annual Training Report with expert guidance.
            </p>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Skills gap analysis</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Training plan development</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Compliance documentation</span>
              </li>
            </ul>
          </div>

          <div className="card p-6">
            <div className="icon-box mb-4">
              <i className="ri-money-dollar-circle-line text-xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Grant Application Support
            </h3>
            <p className="text-gray-600 mb-4">
              Professional assistance with both mandatory and discretionary grant applications to maximise your funding recovery.
            </p>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Application preparation</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Budget optimization</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Submission management</span>
              </li>
            </ul>
          </div>

          <div className="card p-6">
            <div className="icon-box mb-4">
              <i className="ri-user-settings-line text-xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              SDF Advisory Services
            </h3>
            <p className="text-gray-600 mb-4">
              Dedicated Skills Development Facilitator support or training for your internal SDF to ensure effective compliance management.
            </p>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>SDF training programmes</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Ongoing consultation</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>External SDF services</span>
              </li>
            </ul>
          </div>

          <div className="card p-6">
            <div className="icon-box mb-4">
              <i className="ri-shield-check-line text-xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Compliance Monitoring
            </h3>
            <p className="text-gray-600 mb-4">
              Ongoing monitoring and support to ensure continuous compliance with SETA requirements and deadlines.
            </p>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Deadline tracking</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Regular compliance audits</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Risk mitigation</span>
              </li>
            </ul>
          </div>

          <div className="card p-6">
            <div className="icon-box mb-4">
              <i className="ri-graduation-cap-line text-xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Accredited Training Delivery
            </h3>
            <p className="text-gray-600 mb-4">
              QCTO accredited training programmes that meet SETA requirements and contribute to your compliance objectives.
            </p>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>QCTO accredited programmes</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Skills programmes</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Learnerships</span>
              </li>
            </ul>
          </div>

          <div className="card p-6">
            <div className="icon-box mb-4">
              <i className="ri-line-chart-line text-xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              B-BBEE Optimization
            </h3>
            <p className="text-gray-600 mb-4">
              Expert advisory on the skills development element of your B-BBEE scorecard, helping you make the most of your existing strategy.
            </p>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Scorecard advisory</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Scorecard optimization</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Transformation support</span>
              </li>
            </ul>
          </div>

          <div className="card p-6">
            <div className="icon-box mb-4">
              <i className="ri-customer-service-2-line text-xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Ongoing Support & Consultation
            </h3>
            <p className="text-gray-600 mb-4">
              Dedicated support team available for ongoing consultation, troubleshooting, and strategic guidance throughout the year.
            </p>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Support during business hours</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Strategic consultation</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2D7F3E] mr-2 mt-1"></i>
                <span>Regular check-ins</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center mt-12">
          <button className="btn btn-white btn-lg">
            Get Comprehensive SETA Support
          </button>
        </div>
      </div>
    </section>
  );
}